/**
 * Add default roundunit based on selected roundname
 */

export default {
  applyToVersions: "<=2.2.5",
  type: "before",
  name: "roundUnit from roundName",
  migrate(data) {
    if (!data?.project) return data;
    const project = data.project;

    if (project.simulationRoundName) {
      let roundName = project.simulationRoundName.toLowerCase();
      roundName = roundName.normalize("NFD").replace(/\p{Diacritic}/gu, "");
      roundName = roundName.replace(/[-_+–\s]/gu, "");
      switch (roundName) {
        case "round":
        case "rounds":
        case "runde":
        case "runden":
        case "ronda":
        case "rondas":
        case "tour":
        case "tours":
          project.simulationRoundName = null;
          break;

        case "year":
        case "years":
        case "jahr":
        case "jahre":
        case "annee":
        case "annees":
        case "an":
        case "ans":
        case "ano":
        case "anos":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "year";
          break;

        case "halfyear":
        case "halbjahr":
        case "halbesjahr":
        case "semester":
        case "semestre":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "halfYear";
          break;

        case "quarter":
        case "quartal":
        case "jahresquartal":
        case "trimestre":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "quarter";
          break;

        case "month":
        case "monat":
        case "mois":
        case "mes":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "month";
          break;

        case "week":
        case "woche":
        case "semaine":
        case "semana":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "week";
          break;

        case "day":
        case "tag":
        case "jour":
        case "dia":
        case "journee":
          project.simulationRoundName = null;
          project.simulationRoundUnit = "day";
          break;

        default:
          break;
      }
    }

    if (data?.games?.items) {
      for (const simulationId in data.games.items) {
        const simulation = data.games.items[simulationId];
        if (!simulation.roundUnit) {
          simulation.roundUnit = project.simulationRoundUnit;
          simulation.roundLength = project.simulationRoundLength;
          simulation.timeStart = project.simulationTimeStart;
          simulation.durationType = project.simulationDurationType;
        }
      }
    }

    return data;
  }
};
